import React, { Suspense } from 'react';
import { createRoot, Root } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from 'store/store';
import { AppWrapper } from 'App';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import SharedWrapper from 'components/shared/SharedWrapper';

declare global {
    interface Window {
        MiNamespace: any;
    }
}

window.MiNamespace = {
    render: (params: any) => {
        document.dispatchEvent(
            new CustomEvent('mi-render', {
                bubbles: false,
                detail: params,
            }),
        );
    },
};

let sharedInitialized = false;

// One React root per container: re-rendering into the same container must first
// unmount the previous tree, otherwise it stays mounted forever and keeps fighting
// over the shared redux store / query cache (MI-29912)
const containerRoots = new Map<string, Root>();

function initShared() {
    if (sharedInitialized) return;
    sharedInitialized = true;

    document.addEventListener('mi-render', (e: any) => {
        if (e instanceof CustomEvent && e.detail) {
            let containerId = '';

            if (e.detail.props?.container_id && document.getElementById(e.detail.props.container_id)) {
                containerId = e.detail.props.container_id;
            } else if (e.detail.containerId && document.getElementById(e.detail.containerId)) {
                containerId = e.detail.containerId;
            } else {
                containerId = 'miContainer_' + new Date().valueOf() + Math.floor(Math.random() * 1000);
                const container = document.createElement(e.detail.containerType ? e.detail.containerType : 'div');
                container.id = containerId;
                document.body.appendChild(container);
            }

            const previousRoot = containerRoots.get(containerId);
            if (previousRoot) {
                previousRoot.unmount();
            }

            //@ts-ignore
            const root = createRoot(document.getElementById(containerId));
            containerRoots.set(containerId, root);
            const router = createBrowserRouter([
                {
                    path: '*',
                    element: <SharedWrapper e={e} />,
                    loader: (args) => {
                        const paramPath = '/' + encodeURI(args.params['*'] || '');

                        if (args && args.params && args.params['*'] && document.location.pathname != paramPath) {
                            document.location.href = document.location.origin + paramPath;
                        }

                        return args;
                    },
                },
            ]);
            root.render(
                <Provider store={store}>
                    <Suspense>
                        <AppWrapper>
                            <RouterProvider router={router} />
                        </AppWrapper>
                    </Suspense>
                </Provider>,
            );
        }
    });
}

export default initShared;
